import React from 'react';
import PropTypes from 'prop-types';
import './StaticPageContentPanel.scss';

const StaticPageContentPanel = ({ children }) => (
  <div className="static-page__content-panel">{children}</div>
);

StaticPageContentPanel.propTypes = {
  children: PropTypes.node,
};

StaticPageContentPanel.defaultProps = {
  children: null,
};

export default StaticPageContentPanel;
